export const scrollTopId = (id) => {
    window.scrollTo(0, document.getElementById(id).offsetTop - 60);
};

export const scrollBottomToId = (id) => {
    document.getElementById(id).scrollTop = document.getElementById(id).scrollHeight;
};
